import * as React from 'react';
import {StorageSuccessModal} from "../../StorageSuccessModal";
import {AnnualPolicyPremiumTypeEnum} from "@falcon/services";
import {getAmountToDisplay} from "../../../../CommonFunctions";

interface IProps {
    factors: any;
    payFullPrice: boolean;
    cardEnding: string;
    payUpfrontInterest?: boolean;
    upfrontInterestAmount: string;
    renewalPrice: any;
    instalmentsPaidOff: boolean;
    isPaymentsDone: boolean;
}

export class MtaStorageSuccessModal extends React.Component<IProps> {

    public render(): React.ReactNode {
        const factors: any = this.props.factors;
        const refund: boolean = factors?.returnPremium > 0 && factors?.mtaAndDebtCombinedAdditionalAmount === 0;
        const payment: boolean = factors?.additionalPremium > 0 || factors?.mtaAndDebtCombinedAdditionalAmount > 0;

        if (this.props.factors.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL) {
            return this.renderAnnualModals(factors, refund, payment);
        } else {
            return this.renderMonthlyModals(factors, refund, payment);
        }
    }

    private renderAnnualModals(factors: any, refund: boolean, payment: boolean): React.ReactNode {
        let title: React.ReactNode;
        let content: React.ReactNode;

        if (refund) {
            title = "Your Refund is on the way";
            content =
                <>
                    <p className="mb-0">
                        We’ve saved your changes, and we’ll refund you{' '}
                        <span className="font-weight-bold">{getAmountToDisplay(factors.returnPremium)}.</span>{' '}
                        Please allow two days for it to arrive.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment) {
            title = "Payment was successful";
            content =
                <>
                    <p className="mb-0">
                        {getAmountToDisplay(factors.mtaAndDebtCombinedAdditionalAmount || factors.additionalPremium)}
                        &nbsp;has been taken out from your card ending in
                        <span className="font-weight-bold"> {this.props.cardEnding} </span>
                        for the changes on your home policy.<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else {
            title = "All done!";
            content =
                <>
                    <p className="mb-0">
                        We’ve saved your changes, and there’s no extra cost for the changes on your home policy.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        }

        return <StorageSuccessModal title={title} explanationWording={content}/>
    }

    private renderMonthlyModals(factors: any, refund: boolean, payment: boolean): React.ReactNode {
        let title: React.ReactNode;
        let content: React.ReactNode;
        if (refund && !this.props.instalmentsPaidOff) {
            title = "Your payment plan has been updated";
            content =
                <>
                    <p className="mb-0">
                        <span className="font-weight-bold">{getAmountToDisplay(factors.returnPremium)}</span>{' '}
                        has been reduced from your monthly payments.
                        {!this.props.isPaymentsDone && <span> Your future monthly payments will be{' '}
                            <span className="font-weight-bold">{getAmountToDisplay(factors.monthlyPremium)}</span>.
                        </span>}
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (refund && this.props.instalmentsPaidOff) {
            title = "Your Refund is on the way";
            content =
                <>
                    <p className="mb-0">
                        We’ve saved your changes, and we’ll refund you{' '}
                        <span className="font-weight-bold">{getAmountToDisplay(factors.returnPremium)}.</span>{' '}
                        Please allow two days for it to arrive.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment && this.props.payUpfrontInterest) {
            title = "All done!";
            content =
                <>
                    <p className="mb-0">
                        <span className="font-weight-bold">{getAmountToDisplay(this.props.upfrontInterestAmount)}</span>{' '}
                        has been debited from your credit card ending{' '}
                        <span className="font-weight-bold">{this.props.cardEnding}</span><br/>
                        The remaining {getAmountToDisplay(factors.monthlyPaymentSpreadWithInterestAmount || factors.additionalPremium)} has been added to your monthly payments
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment && !this.props.payFullPrice) {
            // prototype doesn't have wording about future monthly payments, probably a mistake? Also there is wording about exact changes that were done
            title = "All done!";
            content =
                <>
                    <p className="mb-0">
                        <span className="font-weight-bold">{getAmountToDisplay(factors.additionalPremium)}</span>{' '}
                        has been added to your monthly payments for the changes on your home policy.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment && this.props.payFullPrice) {
            title = "Payment was successful";
            content =
                <>
                    <p className="mb-0">
                        {getAmountToDisplay(factors.additionalPremium)} has been taken out from your card ending in
                        <span className="font-weight-bold"> {this.props.cardEnding} </span>
                        for the changes on your home policy.<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else {
            title = "All done!";
            content =
                <>
                    <p className="mb-0">
                        We’ve saved your changes, and there’s no extra cost for the changes on your home policy.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        }

        return <StorageSuccessModal title={title} explanationWording={content}/>
    }

    private renderNextYearRenewalPrice(): React.ReactNode {
        if (this.props.renewalPrice) {
            return (
                <p className="font-weight-bold">
                    Your next year’s renewal price will be {getAmountToDisplay(this.props.renewalPrice)}
                </p>
            )
        } else {
            return <></>
        }
    }
}
